import { Component } from '@angular/core';
import { NavbarDropdown } from '../navbar-dropdown/navbar-dropdown';

@Component({
  selector: 'app-navbar',
  imports: [NavbarDropdown],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {

  isDropdownActive: boolean;
  dropdownType: string; 
  private closeTimeout: number;

  constructor() {
    this.closeTimeout = 0
    this.isDropdownActive = false;
    this.dropdownType = '';
  }

  openDropdown = (type: string) => {
    this.dropdownType = type
    clearTimeout(this.closeTimeout);
    this.isDropdownActive = true;
  }
  closeDropdown = () => {
    this.isDropdownActive = false;
  }

  onTriggerLeave() {
    this.closeTimeout = setTimeout(() => {
      this.isDropdownActive = false;
    }, 150)
  }
}
